<template>
  <div>
    <div class="word_3" ref="previewDom">
      <div class="a4">
        <h1 style="font-size: 34px; letter-spacing: 8px; margin-top: 200px">
          贵州省优秀施工企业
        </h1>
        <h1 style="font-size: 34px">申 报 表</h1>
        <p style="font-size: 24px; line-height: 60px; margin-top: 500px">
          申报企业：
          <span
            style="border-bottom: 1px solid black; padding: 0 20px"
            :style="
              alldata.essinfo.msg1 ? 'padding: 0 50px;' : 'padding: 0 100px;'
            "
            >{{ alldata.essinfo.msg1 }}</span
          >(章)
        </p>
        <p style="font-size: 24px; line-height: 60px; margin-right: 24px">
          申报时间：
          <span
            style="border-bottom: 1px solid black; padding: 0 20px"
            :style="
              alldata.essinfo.msg6 ? 'padding: 0 50px;' : 'padding: 0 100px;'
            "
            >{{ alldata.essinfo.msg6 }}</span
          >
        </p>
        <h1 style="font-size: 34px; letter-spacing: 8px; margin-top: 100px">
          贵州省建筑业协会制
        </h1>
      </div>
      <div class="a4">
        <div class="th">
          <div
            class="box justify-center "
            style="width: 200px; height: 60px; line-height: 60px"
          >
            企业名称（全称）
          </div>
          <div
            class="box justify-center"
            style="width: 520px; height: 60px; line-height: 60px"
          >
            {{ alldata.essinfo.msg1 }}
          </div>
        </div>
        <div class="th">
          <div
            class="box justify-center"
            style="width: 200px; height: 60px; line-height: 60px"
          >
            工商注册地址
          </div>
          <div
            class="box justify-center"
            id="condition"
            style="width: 520px; height: 60px;"
          >
            {{ alldata.essinfo.msg2 }}
          </div>
        </div>
        <div class="th">
          <div
            class="box justify-center"
            style="width: 200px; height: 60px; line-height: 60px"
          >
            法定代表人
          </div>
          <div
            class="box justify-center"
            style="width: 110px; height: 60px; line-height: 60px"
          >
            {{ alldata.essinfo.msg3 }}
          </div>
          <div class="box justify-center" style="width: 90px; height: 60px; line-height: 60px">
            电话
          </div>
          <div
            class="box justify-center"
            style="width: 322px; height: 60px; line-height: 60px"
          >
            {{ alldata.essinfo.msg4 }}
          </div>
        </div>
        <div class="th">
          <div
            class="box justify-center"
            style="width: 200px; height: 60px; line-height: 60px"
          >
            申报企业类别
          </div>
          <div
            class="box justify-center"
            style="width: 520px; height: 60px; line-height: 60px"
          >
            1、施工总承包企业{{
              alldata.essinfo.msg5 == 1 ? "☑" : "□"
            }}
            2、专业承包企业{{ alldata.essinfo.msg5 == 0 ? "☑" : "□" }}
          </div>
        </div>
        <div class="th" style="align-items: start">
          <div
            class="box justify-center"
            style="
              width: 30px;
              height: 355px;
              display: flex;
              align-items: center;
            "
          >
            基本条件
          </div>
          <div style="width: 690px; height: 355px">
            <div class="th">
              <div
                class="box justify-center"
                style="width: 30px; height: 60px; line-height: 60px"
              >
                1
              </div>
              <div
                class="box justify-center"
                style="width: 142px; height: 60px; line-height: 60px"
              >
                主项资质及等级
              </div>
              <div
                class="box justify-center"
                style="width: 300px; height: 60px"
                id="condition"
              >
                {{ alldata.condition.msg1 }}
              </div>
              <div
                class="box justify-center"
                style="width: 100px; height: 60px; line-height: 60px"
              >
                取得时间
              </div>
              <div class="box justify-center" style="width: 122px; height: 60px">
                {{ alldata.condition.msg2 }}
              </div>
            </div>
            <div class="th">
              <div
                class="box justify-center"
                style="width: 30px; height: 60px; line-height: 60px"
              >
                2
              </div>
              <div
                class="box justify-center"
                style="width: 560px; height: 60px; line-height: 60px"
              >
                本年度和上一年度发生一般及以上工程质量安全事故及有关投诉
              </div>
              <div
                class="box justify-center"
                style="width: 102px; height: 60px; line-height: 60px"
              >
                有{{ alldata.condition.msg3 == 1 ? "☑" : "□" }} 无{{
                  alldata.condition.msg3 == 0 ? "☑" : "□"
                }}
              </div>
            </div>
            <div class="th">
              <div
                class="box justify-center"
                style="width: 30px; height: 60px; line-height: 60px"
              >
                3
              </div>
              <div
                class="box justify-center"
                style="width: 560px; height: 60px; line-height: 60px"
              >
                本年度和上一年度存在拖欠农民工工资行为
              </div>
              <div
                class="box justify-center"
                style="width: 102px; height: 60px; line-height: 60px"
              >
                有{{ alldata.condition.msg4 == 1 ? "☑" : "□" }} 无{{
                  alldata.condition.msg4 == 0 ? "☑" : "□"
                }}
              </div>
            </div>
            <div class="th">
              <div
                class="box justify-center"
                style="width: 30px; height: 60px; line-height: 60px"
              >
                4
              </div>
              <div
                class="box justify-center"
                style="width: 560px; height: 60px; line-height: 60px"
              >
                本年度和上一年度存在失信、违法违规事件
              </div>
              <div
                class="box justify-center"
                style="width: 102px; height: 60px; line-height: 60px"
              >
                有{{ alldata.condition.msg5 == 1 ? "☑" : "□" }} 无{{
                  alldata.condition.msg5 == 0 ? "☑" : "□"
                }}
              </div>
            </div>
            <div class="th">
              <div
                class="box justify-center"
                style="width: 30px; height: 60px; line-height: 60px"
              >
                5
              </div>
              <div
                class="box justify-center"
                style="width: 560px; height: 60px; line-height: 60px"
              >
                本年度和上一年度存在恶意拖欠建筑业税收行为
              </div>
              <div
                class="box justify-center"
                style="width: 102px; height: 60px; line-height: 60px"
              >
                有{{ alldata.condition.msg6 == 1 ? "☑" : "□" }} 无{{
                  alldata.condition.msg6 == 0 ? "☑" : "□"
                }}
              </div>
            </div>
            <div class="th">
              <div
                class="box justify-center"
                style="width: 30px; height: 60px; line-height: 60px"
              >
                6
              </div>
              <div
                class="box justify-center"
                style="width: 560px; height: 60px; line-height: 60px"
              >
                通过ISO9000系列三项管理体系认证
              </div>
              <div
                class="box justify-center"
                style="width: 102px; height: 60px; line-height: 60px"
              >
                有{{ alldata.condition.msg7 == 1 ? "☑" : "□" }} 无{{
                  alldata.condition.msg7 == 0 ? "☑" : "□"
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="th" style="align-items: start; margin-top: -1px">
          <div
            class="box justify-center"
            style="
              width: 61px;
              height: 533px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            评
            <br />选 <br />指 <br />标
          </div>
          <div style="width: 690px; height: 240px">
            <div class="th">
              <div
                class="box justify-center"
                style="width: 120px; height: 60px; line-height: 60px"
              >
                指标名称
              </div>
              <div
                class="box justify-center"
                style="width: 40px; height: 60px; line-height: 60px"
              >
                序号
              </div>
              <div
                class="box justify-center"
                style="width: 300px; height: 60px; line-height: 60px"
              >
                评审内容
              </div>
              <div
                class="box justify-center"
                style="width: 204px; height: 60px; line-height: 60px"
              >
                实际值
              </div>
            </div>
            <div class="th">
              <div
                class="box justify-center"
                style="width: 120px; height: 237px; line-height: 157px"
              >
                经营规模
              </div>
              <div style="margin-top: -1px">
                <div class="th">
                  <div
                    class="box justify-center"
                    style="width: 40px; height: 60px; line-height: 60px"
                  >
                    1
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 300px; height: 60px; line-height: 60px"
                  >
                    上一年度建筑业总产值
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 204px; height: 60px; line-height: 60px"
                  >
                    {{ alldata.Selection.msg1 }}亿元
                  </div>
                </div>
                <div class="th">
                  <div
                    class="box justify-center"
                    style="width: 40px; height: 60px; line-height: 60px"
                  >
                    2
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 300px; height: 60px; line-height: 60px"
                  >
                    上一年度省外（境外）完成的产值
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 204px; height: 60px; line-height: 60px"
                  >
                    {{ alldata.Selection.msg2 }}亿元
                  </div>
                </div>
                <div class="th">
                  <div
                    class="box justify-center"
                    style="width: 40px; height: 60px; line-height: 60px"
                  >
                    3
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 300px; height: 60px; line-height: 60px"
                  >
                    上一年度现金净流
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 204px; height: 60px; line-height: 60px"
                  >
                    {{ alldata.Selection.msg3 }}亿元
                  </div>
                </div>
                <div class="th">
                  <div
                    class="box justify-center"
                    style="width: 40px; height: 60px; line-height: 60px"
                  >
                    4
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 300px; height: 60px; line-height: 60px"
                  >
                    上一年度净利润总额
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 204px; height: 60px; line-height: 60px"
                  >
                    {{ alldata.Selection.msg4 }}亿元
                  </div>
                </div>
              </div>
            </div>
            <div class="th">
              <div
                class="box justify-center"
                style="width: 120px; height: 60px; line-height: 60px"
              >
                企业管理
              </div>
              <div
                class="box justify-center"
                style="width: 40px; height: 60px; line-height: 60px"
              >
                序号
              </div>
              <div
                class="box justify-center"
                style="width: 300px; height: 60px; line-height: 60px"
              >
                近三年获得企业管理类奖项
              </div>
              <div
                class="box justify-center"
                style="width: 204px; height: 60px; line-height: 60px"
              >
                {{ alldata.Selection.msg5 }}项
              </div>
            </div>
            <div class="th">
              <div
                class="box justify-center"
                style="width: 120px; height: 60px; line-height: 60px"
              >
                工程质量安全
              </div>
              <div
                class="box justify-center"
                style="width: 40px; height: 60px; line-height: 60px"
              >
                序号
              </div>
              <div
                class="box justify-center"
                style="
                  width: 300px;
                  height: 60px;
                  display: flex;
                  align-items: center;
                "
              >
                近三年获得省级及以上工程质量安全类奖项
              </div>
              <div
                class="box justify-center"
                style="width: 204px; height: 60px; line-height: 60px"
              >
                {{ alldata.Selection.msg6 }}项
              </div>
            </div>
            <div class="th">
              <div
                class="box justify-center"
                style="width: 120px; height: 120px; line-height: 120px"
              >
                科学技术
              </div>
              <div style="margin-top: -1px">
                <div class="th">
                  <div
                    class="box justify-center"
                    style="width: 40px; height: 61px; line-height: 60px"
                  >
                    1
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 300px; height: 61px; line-height: 60px"
                  >
                    近三年获得新技术、绿色施工类奖项
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 204px; height: 61px; line-height: 60px"
                  >
                    {{ alldata.Selection.msg7 }}项
                  </div>
                </div>
                <div class="th">
                  <div
                    class="box justify-center"
                    style="width: 40px; height: 60px; line-height: 60px"
                  >
                    2
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 300px; height: 60px; line-height: 60px"
                  >
                    近三年获得技术、专利类奖项
                  </div>
                  <div
                    class="box justify-center"
                    style="width: 204px; height: 60px; line-height: 60px"
                  >
                    {{ alldata.Selection.msg8 }}项
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="a4">
        <div class="box cloum" style="width: 719px; height: 600px; text-align: start">
          企业业绩材料（文字部分）
          <br />
          <span style="display: block; text-indent: 2rem; font-family: '仿宋'"
            >内容应包括企业的基本情况、党的建设、精神文明建设、职工生活水平、企业建立现代企业制度、获奖情况、工程质量和安全生产情况、重视新技术开发和应用情况、无拖欠农民工工资情况等几个方面的业绩。</span
          >
          <p style="margin-top:20px">{{ alldata.Material }}</p>
        </div>
        <div class="th">
          <div
            class="box justify-center"
            style="width: 180px; height: 200px; line-height: 300px"
          >
            企业申报意见
          </div>
          <div
            class="box justify-center"
            style="width: 540px; height: 200px; position: relative"
          >
            <p>{{ alldata.essinfo.msg7 }}</p>
            <div style="position: absolute; right: 40px; bottom: 0px">
              <p>公章</p>
              <br />
              <p>年 月 日</p>
            </div>
            <p style="position: absolute; left: 140px; bottom: 40px">
              法人签字：
            </p>
          </div>
        </div>
        <div class="th">
          <div
            class="box justify-center"
            style="
              width: 180px;
              height: 200px;
              display: flex;
              align-items: center;
            "
          >
            推荐意见（各市、州建筑业协会或企业主管部门）
          </div>
          <div
            class="box justify-center"
            style="width: 540px; height: 200px; position: relative"
          >
            <p>{{ alldata.essinfo.msg8 }}</p>
            <div style="position: absolute; right: 40px; bottom: 0px">
              <p>公章</p>
              <br />
              <p>年 月 日</p>
            </div>
          </div>
        </div>
      </div>
      <div class="a3">
      <div class="a3-box">
      <div class="box" style="height:50px;width:1094px">
        <h1 style="font-size:24px;margin:0;line-height:50px">申报{{ year }}年度贵州省优秀施工企业情况综合表</h1>
      </div>
      <div class="box" style="width:1094px;height:50px;display:flex;justify-content:center;align-items:center;padding:0 10px">
        （排名不分先后）
      </div>
      <div class="th">
        <div class="box justify-center" style="height:100px;width:41px">序号</div>
        <div class="box justify-center" style="height:100px;width:100px">申报企业名称</div>
        <div class="box justify-center" style="height:100px;width:80px">申报企业类别</div>
        <div class="box justify-center" style="height:100px;width:120px">主项资质及等级</div>
        <div class="box justify-center" style="height:100px;width:300px">
          <div class="box justify-center" style="height:35px;width:300px">
              进三年获市、州（或行业）以上奖励情况
          </div>
          <div class="th">
            <div class="box justify-center" style="height:65px;width:80px">企业管理奖</div>
            <div class="box justify-center" style="height:65px;width:80px">工程质安奖</div>
            <div class="box justify-center" style="height:65px;width:80px">新技术、绿色施工类</div>
            <div class="box justify-center" style="height:65px;width:63px">技术、专利类</div>
          </div>
        </div>
        <div class="box justify-center" style="height:100px;width:300px">
          <div class="box justify-center" style="height:35px;width:300px">
              经营规模（{{ year-1 }}年度数据，单位为亿元）
          </div>
          <div class="th">
            <div class="box justify-center" style="height:65px;width:80px">建筑业总产值</div>
            <div class="box justify-center" style="height:65px;width:80px">省外（境外）完成的产值</div>
            <div class="box justify-center" style="height:65px;width:80px">现金净流</div>
            <div class="box justify-center" style="height:65px;width:63px">净利润总额</div>
          </div>
        </div>
        <div class="box justify-center" style="height:100px;width:120px">推荐单位</div>
        <div class="box justify-center" style="height:100px;width:40px">备注</div>
      </div>
      <div class="th">
        <div class="box justify-center" style="height:60px;width:41px">1</div>
        <div class="box justify-center" style="height:60px;width:100px">{{ alldata.essinfo.msg1 }}</div>
        <div class="box justify-center" style="height:60px;width:80px">{{ alldata.essinfo.msg5=='1'?'施工总承包企业':'专业承包企业' }}</div>
        <div class="box justify-center" style="height:60px;width:120px">{{ alldata.condition.msg1 }}</div>
        <div class="box justify-center" style="height:60px;width:81px">{{ alldata.Selection.msg5 }}</div>
        <div class="box justify-center" style="height:60px;width:80px">{{ alldata.Selection.msg6 }}</div>
        <div class="box justify-center" style="height:60px;width:80px">{{ alldata.Selection.msg7 }}</div>
        <div class="box justify-center" style="height:60px;width:63px">{{ alldata.Selection.msg8 }}</div>
        <div class="box justify-center" style="height:60px;width:80px">{{ alldata.Selection.msg1 }}</div>
        <div class="box justify-center" style="height:60px;width:80px">{{ alldata.Selection.msg2 }}</div>
        <div class="box justify-center" style="height:60px;width:80px">{{ alldata.Selection.msg3 }}</div>
        <div class="box justify-center" style="height:60px;width:62px">{{ alldata.Selection.msg4 }}</div>
        <div class="box justify-center" style="height:60px;width:120px">{{ alldata.essinfo.msg1 }}</div>
        <div class="box justify-center" style="height:60px;width:40px"></div>
      </div>
      <!-- <div class="th">
        <div class="box justify-center" style="height:140px;width:41px">例</div>
        <div class="box justify-center" style="height:140px;width:100px">贵州省地质资料馆暨地质博物馆建设项目</div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">承建单位：中铁五局集团建筑工程有限责任公司</div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程项目经理：刘建海 </div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程技术负责人：陈代龙</div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">参建单位：贵州飞大装饰有限公司</div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程项目经理：田进 </div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程技术负责人：李小保</div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">建设单位：贵州省自然资源厅</div>
            <div class="box justify-start" style="width:160px;height:69px;font-size:16px;text-align:start">主要负责人：袁景国 </div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">设计单位：贵州省建筑设计研究院有限责任公司</div>
            <div class="box justify-start" style="width:160px;height:69px;font-size:16px;text-align:start">主要负责人：代宁 </div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">质量监督单位：贵阳市观山湖区建设工程质量监督站</div>
            <div class="box justify-start" style="width:160px;height:69px;font-size:16px;text-align:start">主要负责人：黄明岗 </div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">监理单位：贵州省建筑设计研究院有限责任公司</div>
            <div class="box justify-start" style="width:160px;height:69px;font-size:16px;text-align:start">工程总监：赵应虎 </div>
          </div>
        </div>
      </div> -->
      
      </div>
    </div>
    </div>
    <div class="botview">
      <div class="a3">
        <div class="th" style="padding: 0 60px">
          <div class="box justify-center" style="width: 120px; height: 240px">
            1、企业营业执照扫描件
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            2、企业资质证书扫描件
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            3、ISO9000系列三项管理体系认证证书扫描件（必须三项）(1)
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            3、ISO9000系列三项管理体系认证证书扫描件（必须三项）(2)
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            3、ISO9000系列三项管理体系认证证书扫描件（必须三项）(3)
          </div>
          <div class="box justify-center" style="width: 220px; height: 240px">
            4、企业法人承诺书（原件） 内容应包括：1、申报资料真实有效。2、本年度和上一年度没有发生一般及以上工程质量安全事故及有关投诉，无拖欠农民工工资、建筑业税收行为、无失信、违法违规事件(复印件)
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            5、近三年获得企业管理类奖项
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            6、近三年获得省级及以上工程质量安全类奖项
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            7、近三年获得新技术、绿色施工类奖项
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            8、近三年获得技术、专利类奖项
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            9、上一年度企业财务审计报表扫描件
          </div>
          <div class="box justify-center" style="width: 120px; height: 240px">
            10、贵州省优秀施工企业申报表
          </div>
        </div>
        <div class="th" style="padding: 0 60px">
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg1"
              :href="alldata.enclosure.msg1[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg2"
              :href="alldata.enclosure.msg2[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg3"
              :href="alldata.enclosure.msg3[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg4"
              :href="alldata.enclosure.msg4[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg5"
              :href="alldata.enclosure.msg5[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 220px; height: 200px">
            <a
              v-if="alldata.enclosure.msg6"
              :href="alldata.enclosure.msg6[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg7"
              :href="alldata.enclosure.msg7[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg8"
              :href="alldata.enclosure.msg8[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg9"
              :href="alldata.enclosure.msg9[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg10"
              :href="alldata.enclosure.msg10[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg11"
              :href="alldata.enclosure.msg11[0].url"
              target="_blank"
              >有</a
            >
          </div>
          <div class="box justify-center" style="width: 120px; height: 200px">
            <a
              v-if="alldata.enclosure.msg12"
              :href="alldata.enclosure.msg12[0].url"
              target="_blank"
              >有</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import self_adaption from './adaption'
export default {
  props: {
    alldata: {
      type: Object,
      default: {},
      year:""
    },
  },
  data() {
    return {};
  },
  created() {
    let nowyaer = new Date().getFullYear()
    this.year = nowyaer
  },
  mounted() {
    self_adaption()
    this.$emit('previewDom',this.$refs.previewDom)//整页DOM上传至父组件
  },
  methods:{
    
  }
};
</script>

<style lang="less" scoped>
.word_3 {
  width: 841px;
  margin: 0 auto;
}
.a4 {
  padding: 40px 60px;
  width: 841px;
  margin: 0 auto;
  margin-top: 32px;
  background: #ffffff;
  box-sizing: border-box;
  color: black;
  p,
  h1 {
    font-family: "仿宋";
  }
  .th {
    display: flex;
    align-items: center;
    font-family: "仿宋";
  }
  .box {
    box-sizing: border-box;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    text-align: center;
    font-size: 18px;
  }
  .justify-center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .justify-start{
    display: flex;
    align-items: flex-start;
    justify-content: start;
  }
  .cloum{

  }
}
.a3 {
  width: 841px;
  height: 1189px;
  margin: 0 auto;
  margin-top: 32px;
  background: #ffffff;
  box-sizing: border-box;
  color: black;
  position: relative;
  .a3-box {
    height: 841px;
    width: 1189px;
    transform: rotate(90deg);
    position: absolute;
    left: -236px;
    top: 240px;
  }
  .th {
    display: flex;
    align-items: center;
    font-family: "仿宋";
  }
  .box {
    box-sizing: border-box;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    text-align: center;
    font-size: 14px;
    word-break: break-all;
  }
  .justify-center {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .blue {
    &:hover {
      color: rgb(81, 143, 201);
    }
  }
  .justify-start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: start;
  }
}
</style>